export const numRows = 8;
export const numCols = 8;

export interface Point { x: number, y: number; }
export interface Size { width: number, height: number; }
